module.exports = __webpack_public_path__ + "img/cert.7ee08a08.jpg";